import React from 'react';

const Spinner = () => {
    return <div style={{paddingTop: '50px', textAlign: 'center'}}><i className='fa fa-5x fa-spinner fa-spin'/></div>;
};

export default Spinner;